<label [ngClass]="{ 'text-danger': invalid, 'text-success': valid }">
    <ng-content></ng-content>
</label>
